var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSandClock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.704,
    y1: 2.244,
    x2: 0.1,
    y2: -0.211,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#405cfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab5fc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4074",
    "data-name": "Group 4074",
    transform: "translate(-453.5 -634.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    transform: "translate(453.5 634.5)",
    fill: "#e9f6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun-hourglass-3364266",
    d: "M175.028,17.956v1.77a.442.442,0,0,0,.441.441h16.81a.442.442,0,0,0,.441-.441v-1.77a.442.442,0,0,0-.441-.441H175.448a.445.445,0,0,0-.419.441Zm1.325,3.1v2.655a7.805,7.805,0,0,0,4.562,7.079,7.774,7.774,0,0,0-4.562,7.075v2.656h.885V37.861a7.087,7.087,0,0,1,4.993-6.658.442.442,0,0,0,0-.839,7.087,7.087,0,0,1-4.993-6.658V21.051Zm14.155,0v2.655a7.09,7.09,0,0,1-5,6.658.442.442,0,0,0,0,.839,7.089,7.089,0,0,1,5,6.658v2.656h.885V37.861a7.838,7.838,0,0,0-4.563-7.075,7.834,7.834,0,0,0,4.563-7.079V21.052Zm-11.987,2.214a.442.442,0,0,0-.4.441,5.75,5.75,0,1,0,11.5,0,.442.442,0,0,0-.441-.441H178.521Zm5.345,7.07a.442.442,0,0,0-.438.45v.885a.442.442,0,1,0,.885,0v-.885A.442.442,0,0,0,183.866,30.335Zm0,2.654a.442.442,0,0,0-.438.447v.885a.442.442,0,1,0,.885,0v-.885A.442.442,0,0,0,183.866,32.99Zm.006,2.662a3.491,3.491,0,0,0-1.815.692,21.6,21.6,0,0,0-3.824,3.435.442.442,0,0,0,.33.738h10.619a.442.442,0,0,0,.329-.738,22.049,22.049,0,0,0-3.823-3.435,3.493,3.493,0,0,0-1.816-.692Zm-8.4,5.75a.442.442,0,0,0-.441.441v1.769a.442.442,0,0,0,.441.444h16.81a.442.442,0,0,0,.441-.444V41.842a.442.442,0,0,0-.441-.441Z",
    transform: "translate(291.977 625.787)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandClock);
export default __webpack_public_path__ + "static/media/sand-clock.df4b30fdbde6c09e6caf0188fd69bb85.svg";
export { ForwardRef as ReactComponent };